export interface BuildDefinition {
    BuildDefinitionId: number;
    Name: string;
}